<script>
	import { createEventDispatcher } from 'svelte';
	import Icon from '../icons/Icon.svelte';

	const dispatch = createEventDispatcher();

	export let connectionTab = 'qrcode'; // 'qrcode' | 'pairing-code'
	export let qrCodeDataUrl = '';
	export let qrCountdown = 0;
	export let isConnecting = false;
	export let phoneInput = '';
	export let showPairingCode = false;
	export let pairingCode = '';

	function handleSwitchTab(tab) {
		connectionTab = tab;
		dispatch('switchTab', tab);
	}

	function handleRefreshQRCode() {
		dispatch('refreshQRCode');
	}

	function handleStartConnection() {
		dispatch('startConnection');
	}

	function handleGeneratePairingCode() {
		dispatch('generatePairingCode');
	}
</script>

<div class="wa-connect-page">
	<div class="connect-card-box">
		<!-- Topo do Card de Conexão -->
		<div class="connect-header">
			<div class="connect-logo-badge">
				<div class="wpp-logo-icon">
					<Icon name="whatsapp" size={24} />
				</div>
				<div>
					<h3>Conectar WhatsApp do Restaurante</h3>
					<span class="sub-connect">Vincule o número do seu delivery para o Robô de IA responder clientes e anotar pedidos</span>
				</div>
			</div>

			<!-- Abas: QR Code ou Código por Telefone -->
			<div class="auth-tabs" role="tablist">
				<button
					class="auth-tab-btn"
					class:active={connectionTab === 'qrcode'}
					on:click={() => handleSwitchTab('qrcode')}
					role="tab"
					aria-selected={connectionTab === 'qrcode'}
				>
					<Icon name="shopping-bag" size={14} />
					<span>Escanear QR Code</span>
				</button>
				<button
					class="auth-tab-btn"
					class:active={connectionTab === 'pairing-code'}
					on:click={() => handleSwitchTab('pairing-code')}
					role="tab"
					aria-selected={connectionTab === 'pairing-code'}
				>
					<Icon name="lock" size={14} />
					<span>Código por Telefone</span>
				</button>
			</div>
		</div>

		<!-- Corpo da Conexão -->
		<div class="connect-body">
			{#if connectionTab === "qrcode"}
				<div class="qr-method-grid">
					<!-- Passo a Passo -->
					<div class="steps-column">
						<h4>Como conectar com o celular do restaurante:</h4>
						<ol class="steps-list">
							<li>
								<span class="step-num">1</span>
								<div class="step-text">
									<strong>Abra o WhatsApp</strong> no celular do restaurante.
								</div>
							</li>
							<li>
								<span class="step-num">2</span>
								<div class="step-text">
									Toque em <strong>Mais opções</strong> (⋮ no Android) ou em <strong>Configurações / Ajustes</strong> (no iPhone).
								</div>
							</li>
							<li>
								<span class="step-num">3</span>
								<div class="step-text">
									Toque em <strong>Aparelhos conectados</strong> e depois em <strong>Conectar um aparelho</strong>.
								</div>
							</li>
							<li>
								<span class="step-num">4</span>
								<div class="step-text">
									Aponte a câmera do seu celular para este QR Code para concluir a vinculação.
								</div>
							</li>
						</ol>

						<div class="security-pill">
							<Icon name="shield-check" size={15} />
							<span>Conexão Multi-Device oficial com criptografia de ponta a ponta e proteção Anti-Ban integrada.</span>
						</div>
					</div>

					<!-- O QR Code Interativo -->
					<div class="qrcode-column">
						<div class="qr-canvas-frame">
							{#if qrCodeDataUrl}
								<img src={qrCodeDataUrl} alt="Escaneie o QR Code no seu WhatsApp" class="real-qr-image" />
							{:else if isConnecting}
								<div class="qr-loading-box">
									<span class="qr-spinner"><Icon name="refresh" size={26} className="spin" /></span>
									<p><strong>Gerando QR Code Oficial...</strong></p>
									<small>Preparando conexão com os servidores do WhatsApp</small>
								</div>
							{:else}
								<div class="qr-loading-box disconnected-placeholder">
									<span class="qr-spinner placeholder-icon"><Icon name="whatsapp" size={32} /></span>
									<p><strong>WhatsApp Desconectado</strong></p>
									<small>Clique no botão abaixo para gerar o QR Code oficial de pareamento</small>
								</div>
							{/if}
						</div>

						<div class="qr-refresh-timer">
							<span>
								<Icon name="clock" size={12} />
								{#if qrCodeDataUrl && qrCountdown > 0}
									Expira em {qrCountdown}s
								{:else if qrCodeDataUrl && qrCountdown <= 0}
									QR Code expirado
								{:else if isConnecting}
									Gerando QR Code oficial...
								{:else}
									Aguardando conexão
								{/if}
							</span>
							{#if qrCodeDataUrl}
								<button class="btn-refresh-qr" on:click={handleRefreshQRCode} title="Recarregar QR Code">
									<Icon name="refresh" size={12} /> Atualizar
								</button>
							{/if}
						</div>

						<!-- Botão de Ação Imediata -->
						<button class="btn-primary full-width" on:click={handleStartConnection} disabled={isConnecting}>
							{#if isConnecting}
								<Icon name="refresh" size={14} className="spin" /> Conectando com o celular...
							{:else if qrCodeDataUrl}
								<Icon name="refresh" size={14} /> Recarregar QR Code Oficial
							{:else}
								<Icon name="play" size={14} /> Gerar QR Code de Conexão
							{/if}
						</button>
					</div>
				</div>
			{:else}
				<!-- Método 2: Código de Pareamento por Telefone -->
				<div class="pairing-method-box">
					<div class="pairing-instructions">
						<h4>Conectar com número de telefone (Sem Câmera)</h4>
						<p>Digite o seu número de WhatsApp com DDD para gerar o código oficial de 8 dígitos:</p>
					</div>

					<div class="phone-input-row">
						<div class="phone-input-wrapper">
							<span class="country-prefix">+55</span>
							<input type="text" placeholder="DDD + Número (ex: 11988887777)" bind:value={phoneInput} />
						</div>
						<button class="btn-primary" on:click={handleGeneratePairingCode} disabled={isConnecting}>
							{#if isConnecting}
								<Icon name="refresh" size={14} className="spin" /> Gerando código...
							{:else}
								Gerar Código
							{/if}
						</button>
					</div>

					{#if showPairingCode}
						<div class="code-display-card">
							<span class="code-title">Digite este código no seu WhatsApp:</span>
							<div class="code-badge">{pairingCode}</div>
							<small class="code-help">No WhatsApp do celular, vá em: <strong>Aparelhos Conectados</strong> > <strong>Conectar com número de telefone</strong>.</small>
						</div>
					{/if}
				</div>
			{/if}
		</div>
	</div>
</div>

<style>
/* ================= TELA DE CONEXÃO ================= */
	.wa-connect-page {
		display: flex;
		width: 100%;
		flex: 1;
		background: var(--neutral-bg, #F8FAFC);
		align-items: center;
		justify-content: center;
		padding: 24px;
		overflow-y: auto;
	}

	.connect-card-box {
		width: 880px;
		max-width: 95vw;
		background: var(--neutral-surface, #FFFFFF);
		border-radius: var(--radius-lg, 16px);
		box-shadow: var(--shadow-modal, 0 20px 25px -5px rgba(0, 0, 0, 0.1));
		border: 1px solid var(--neutral-border, #E2E8F0);
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.connect-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 22px 28px;
		border-bottom: 1px solid var(--neutral-border, #E2E8F0);
		background: var(--neutral-surface-hover, #F8FAFC);
		flex-wrap: wrap;
		gap: 16px;
	}

	.connect-logo-badge {
		display: flex;
		align-items: center;
		gap: 14px;
	}

	.wpp-logo-icon {
		width: 44px;
		height: 44px;
		border-radius: 12px;
		background: #DCFCE7;
		color: #16A34A;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.connect-header h3 {
		margin: 0;
		font-size: 17px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.sub-connect {
		font-size: 12px;
		color: var(--text-secondary, #64748B);
	}

	.auth-tabs {
		display: flex;
		gap: 6px;
		background: #E2E8F0;
		padding: 4px;
		border-radius: var(--radius-md, 10px);
	}

	.auth-tab-btn {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 8px 14px;
		border-radius: 8px;
		border: none;
		background: transparent;
		font-size: 12.5px;
		font-weight: 700;
		color: var(--text-secondary, #475569);
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.auth-tab-btn.active {
		background: #FFFFFF;
		color: var(--text-primary, #0F172A);
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	}

	.connect-body {
		padding: 32px 36px;
	}

	.qr-method-grid {
		display: grid;
		grid-template-columns: 1fr 300px;
		gap: 36px;
		align-items: center;
	}

	.steps-column h4 {
		margin: 0 0 16px 0;
		font-size: 15px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.steps-list {
		list-style: none;
		padding: 0;
		margin: 0 0 24px 0;
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.steps-list li {
		display: flex;
		align-items: flex-start;
		gap: 12px;
	}

	.step-num {
		width: 26px;
		height: 26px;
		border-radius: 50%;
		background: var(--neutral-surface-hover, #F1F5F9);
		border: 1px solid var(--neutral-border, #CBD5E1);
		color: var(--text-primary, #0F172A);
		font-weight: 800;
		font-size: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.step-text {
		font-size: 13.5px;
		color: var(--text-secondary, #334155);
		line-height: 1.45;
	}

	.security-pill {
		display: flex;
		align-items: center;
		gap: 8px;
		background: #F0FDF4;
		border: 1px solid #BBF7D0;
		border-radius: var(--radius-md, 10px);
		padding: 12px 14px;
		font-size: 12px;
		color: #166534;
		line-height: 1.4;
	}

	.qrcode-column {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 12px;
	}

	.qr-canvas-frame {
		width: 230px;
		height: 230px;
		background: #FFFFFF;
		border: 2px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-lg, 16px);
		padding: 10px;
		box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	.real-qr-image {
		width: 100%;
		height: 100%;
		object-fit: contain;
		border-radius: 8px;
		display: block;
	}

	.qr-loading-box {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		padding: 16px;
		box-sizing: border-box;
	}

	.qr-loading-box p {
		margin: 8px 0 2px 0;
		font-size: 13px;
		color: var(--text-primary, #0F172A);
	}

	.qr-loading-box small {
		font-size: 11px;
		color: var(--text-muted, #94A3B8);
	}

	.placeholder-icon {
		color: #CBD5E1;
	}

	.qr-refresh-timer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		font-size: 11.5px;
		color: var(--text-secondary, #64748B);
		padding: 0 4px;
	}

	.btn-refresh-qr {
		background: transparent;
		border: none;
		color: var(--brand-primary, #FF6A00);
		font-weight: 700;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 2px 6px;
	}

	.full-width {
		width: 100%;
		justify-content: center;
	}

	.pairing-method-box {
		display: flex;
		flex-direction: column;
		gap: 16px;
		max-width: 520px;
		margin: 0 auto;
	}

	.pairing-instructions h4 {
		margin: 0 0 6px 0;
		font-size: 16px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.pairing-instructions p {
		margin: 0;
		font-size: 13px;
		color: var(--text-secondary, #64748B);
	}

	.phone-input-row {
		display: flex;
		gap: 10px;
	}

	.phone-input-wrapper {
		display: flex;
		align-items: center;
		background: #FFFFFF;
		border: 1px solid var(--neutral-border, #CBD5E1);
		border-radius: var(--radius-md, 10px);
		padding: 0 12px;
		flex: 1;
	}

	.country-prefix {
		font-size: 13px;
		font-weight: 700;
		color: var(--text-secondary, #64748B);
		margin-right: 8px;
	}

	.phone-input-wrapper input {
		border: none;
		outline: none;
		width: 100%;
		font-size: 14px;
		padding: 10px 0;
		font-weight: 600;
	}

	.code-display-card {
		background: #F0FDF4;
		border: 1px solid #BBF7D0;
		border-radius: var(--radius-lg, 16px);
		padding: 20px;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
	}

	.code-title {
		font-size: 12px;
		font-weight: 700;
		color: #166534;
		text-transform: uppercase;
	}

	.code-badge {
		font-size: 28px;
		font-weight: 900;
		letter-spacing: 4px;
		color: #15803D;
		background: #FFFFFF;
		padding: 8px 24px;
		border-radius: 12px;
		border: 2px dashed #86EFAC;
	}

	.code-help {
		font-size: 12px;
		color: #166534;
	}
	.btn-primary {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		background: #22C55E;
		color: #FFFFFF;
		font-weight: 700;
		font-size: 13px;
		padding: 10px 18px;
		border-radius: var(--radius-md, 10px);
		border: none;
		cursor: pointer;
		transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
		box-shadow: 0 2px 4px rgba(34, 197, 94, 0.2);
	}

	.btn-primary:hover:not(:disabled) {
		background: #16A34A;
		box-shadow: 0 4px 8px rgba(34, 197, 94, 0.3);
		transform: translateY(-1px);
	}

	.btn-primary:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.btn-primary.full-width {
		width: 100%;
	}

	@media (max-width: 1024px) {
		.qr-method-grid {
			grid-template-columns: 1fr;
		}
	}

</style>
